import { TransProp } from '@icc/shared/helpers';
import { RollerGuideOverlay } from './guide-overlay';

/** Prowadzenia */
export class RollerGuidesOverlays {
    id: number;
    /** Id żaluzji */
    shutterId: number;
    /** Lewe prowdzenie.
     *
     * Gdy jest przygotowanie pod prowadzenie to jest równe `null`
     */
    @TransProp()
    left: RollerGuideOverlay | null;
    /**
     * Prawe prowadzenie
     *
     * Gdy jest przygotowanie pod prowadzenie to jest równe `null`
     */
    @TransProp()
    right: RollerGuideOverlay | null;

    /** Prowadzenia podziałowe moskitier */
    mosquitoScreens: {
        overlay: RollerGuideOverlay;
        leftMosquitoScreenId: number | null;
        rightMosquitoScreenId: number | null;
    }[];
}
